/**
 * Returns the current url the app is running at
 */
export function getAppUrl(): string {
  if (typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    return `${url.protocol}//${url.host}`;
  }
  return '';
}
